import type { OrganizationSettings } from '@chukua/common';
import { ImagePlus } from 'lucide-react';
import { CompanyLogoUpload } from './CompanyLogoUpload';
import { SettingsCard } from './SettingsCard';
import type { LogoVariant } from '../company-settings.api';

interface CompanyBrandingProps {
  settings: OrganizationSettings;
  savingLogo: LogoVariant | null;
  onUploadLogo: (variant: LogoVariant, file: File) => void;
  onRemoveLogo: (variant: LogoVariant) => void;
}

/** The tenant logo, shown by TenantLogo across the app once set — light for normal surfaces, dark for the login panel and sidebar. */
export function CompanyBranding({ settings, savingLogo, onUploadLogo, onRemoveLogo }: CompanyBrandingProps) {
  return (
    <SettingsCard icon={ImagePlus} title="Branding">
      <div className="flex flex-col gap-5">
        <CompanyLogoUpload
          variant="light"
          label="Logo"
          hint="Shown on light surfaces: the sidebar and most of the app."
          logoUrl={settings.logoUrl}
          saving={savingLogo === 'light'}
          onUpload={(file) => onUploadLogo('light', file)}
          onRemove={() => onRemoveLogo('light')}
        />
        <CompanyLogoUpload
          variant="dark"
          label="Dark-surface logo"
          hint="For the login panel and dark mode. Falls back to the logo above when not set."
          logoUrl={settings.logoDarkUrl}
          saving={savingLogo === 'dark'}
          onUpload={(file) => onUploadLogo('dark', file)}
          onRemove={() => onRemoveLogo('dark')}
        />
      </div>
    </SettingsCard>
  );
}
